enum SortOrders {
  ASC = 'Ascending',
  DESC = 'Descending',
}

enum AdminPaginationStyle {
  WITH_ALL_PAGES = 'all-pages',
  ONLY_NEXT_PAGE = 'next-page',
  WITH_ROW_PER_NEXT_PAGE = 'row-per-next-page',
  WITH_ALL_PAGES_AND_ROW_SELECTOR = 'all-pages-and-row-selector',
}

enum TableVersion {
  ADMIN = 'ADMIN',
  WEB = 'WEB',
}

enum TableRowType {
  DEFAULT = 'default',
  COMPACT = 'compact',
}

enum RowsPerPageSelectorVariant {
  DEFAULT = 'default',
  COMPACT = 'compact',
}

export { SortOrders, AdminPaginationStyle, TableVersion, TableRowType, RowsPerPageSelectorVariant };
